/** A value-over-label metric tile used in the scan module rails. */
export function Metric(props: { label: string; value: string }) {
  return (
    <div class="signal-module-metric">
      <strong>{props.value}</strong>
      <span>{props.label}</span>
    </div>
  );
}
